import { SharkOffIcon } from './SharkOffIcon';

/**
 * author: Colton Wiscombe
 * id 4CF1A54B-034F-4AB6-A3B2-6ED16E550261
 * name shark-off
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shark-off.svg
 * tags
 * - Animal 
 */
export const JawsOffIcon = SharkOffIcon;
export default JawsOffIcon